import React, { useContext, useEffect, useState } from 'react';

import IconButton from '@mui/material/IconButton';
import { useMap } from '@vis.gl/react-maplibre';
import { TravelExplore } from '@mui/icons-material';
import { ExploreContext } from '../context/ExploreContext';

export const CalcButtonContainer = ({
  reCalcActive,
  setStatus,
  fetchData,
  locationFeature,
  handleLocationFeature,
}) => {
  const { mymap } = useMap();

  const { noRequest, setNoRequest, resetDataToInitValue, startDate } =
    useContext(ExploreContext);

  const [executeLoad, setExecuteLoad] = useState(false);

  const style = {
    calcButton: {
      display: 'flex',
      width: 100,
      textTransform: 'none',
    },
    iconButton: {
      backgroundColor: '#1565c0',
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: '#D3D3D3',
        color: '#000000',
      },
      '&:disabled': {
        backgroundColor: '#1565c0',
        color: '#FFFFFF',
        opacity: 0.5,
      },
    },
  };

  const handleButtonFetchData = () => {
    resetDataToInitValue();
    setExecuteLoad(false);

    if (mymap) {
      if (noRequest) {
        setNoRequest(false);
      }
      if (locationFeature) {
        handleLocationFeature(null);
      }
      const bbox = mymap.getBounds();
      fetchData(bbox, startDate).catch((error) => {
        console.log('error loading layer bbox updated', error);
      });
    }
  };

  useEffect(() => {
    if (!locationFeature && mymap && !executeLoad) {
      setStatus('loading');
      const bbox = mymap.getBounds();
      fetchData(bbox, startDate)
        .catch((error) => {
          console.log('error loading layer bbox updated', error);
        })
        .then(() => {
          setStatus('idle');
        });
    }
  }, [startDate]);

  useEffect(() => {
    if (executeLoad) {
      handleButtonFetchData();
    }
  }, [executeLoad]);

  return (
    <IconButton
      sx={style.iconButton}
      size='small'
      disabled={executeLoad || !reCalcActive}
      onClick={() => {
        setExecuteLoad(true);
      }}
    >
      <TravelExplore />
    </IconButton>
  );
};
